/*
* @providesModule WithdrawalSuccessModalStyle
* 
*/

import SkillzStyle from 'SkillzStyle';
import {StyleSheet} from 'react-native';

const {
  viewSecondaryColor,
  fontSecondary,
  fontSizeH4,
  fontRegular,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  contentContainer: {
    backgroundColor: '#FFF',
    padding: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },

  successModalIcon: {
    width: 60,
    height: 60,
    marginBottom: 20,
  },

  bodyText: {
    ...fontRegular,
    ...fontSizeH4,
    color: 'rgb(51, 51, 51)',
    textAlign: 'center',
  },

  okButton: {
    width: 130,
    height: 34,
    marginTop: 20,
    alignSelf: 'center',
  },

  okButtonText: {
    ...fontSecondary,
    ...fontSizeH4,
    color: viewSecondaryColor.backgroundColor,
  },

});
